import React from "react"

/* Bold the figures in Clara's answers and steps so they can be read at a glance.

   A figure is a number with its unit right after it: "95%", "341 minutes", "6 hours",
   "12 h", "303 readings", "3 episodes", "191.6 mmHg". A bare number (a time, a date, a
   patient name) stays plain. In a range ("between 95 and 191.6 mmHg", "90 to 100 mmHg") the first
   number is bold too, so it does not read as plain next to a bold one.

   Only the display changes. The text, and what Copy puts on the clipboard, stay as Clara
   sent them. */

const NUMBER = String.raw`[-−]?(?:\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?)`
const UNIT = String.raw`%|°[CF]|(?:mm ?Hg|bpm|breaths\/min|seconds?|secs?|minutes?|mins?|hours?|hrs?|h|days?|readings?|episodes?)(?![A-Za-z])`
const FIGURE = new RegExp(String.raw`(?<![\w.,:/])(?:(?<=\bbetween\s)(${NUMBER})(\s+and\s+)|(${NUMBER})(\s*(?:to|-|–)\s*))?(${NUMBER}[\s-]?(?:${UNIT}))`, "g")

// [start, end) of every figure in text.
export function figureRanges(text) {
	const ranges = []
	for (const match of (text || "").matchAll(FIGURE)) {
		const [whole] = match
		const low = match[1] ?? match[3]
		const joiner = match[2] ?? match[4] ?? ""
		if (low) {
			ranges.push([match.index, match.index + low.length])
		}
		ranges.push([match.index + (low ? low.length + joiner.length : 0), match.index + whole.length])
	}
	return ranges
}

/* The text with its figures in <strong>. A streamed answer renders one word at a time,
   so it passes the ranges of its whole block and the word's offset in it: a figure split
   over two words ("341" then "minutes") is bold from its first word on, and no tag is
   ever left open. Text with no figure comes back as the same string. */
export function boldFigures(text, ranges = figureRanges(text), offset = 0) {
	const end = offset + text.length
	const parts = []
	let at = offset
	for (const [from, to] of ranges) {
		if (to <= at || from >= end) {
			continue
		}
		const start = Math.max(from, at)
		const stop = Math.min(to, end)
		if (start > at) {
			parts.push(text.slice(at - offset, start - offset))
		}
		parts.push(<strong key={start}>{text.slice(start - offset, stop - offset)}</strong>)
		at = stop
	}
	if (!parts.length) {
		return text
	}
	if (at < end) {
		parts.push(text.slice(at - offset))
	}
	return parts
}
